export const formatPhone = (src) => {
  try {
    const p = src.replace(/\D/g, "");
    let res = "";
    if (p.substring(0, 1) == "7") {
      res += `+7 (${p.substring(1, 4)}) `;
    } else {
      res += `8-${p.substring(1, 4)}-`;
    }

    return (
      res +
      p.substring(4, 7) +
      "-" +
      p.substring(7, 9) +
      "-" +
      p.substring(9, 11)
    );
  } catch (e) {
    console.error(e);
    return "";
  }
};
export const formatTel = (src) => {
  try {
    let res = "tel:";
    const p = src.replace(/\D/g, "");
    if (p.substring(0, 1) == "7") res += "+";
    return res + p;
  } catch (e) {
    console.error(e);
    return "";
  }
};

export const maskInp = (_v) => {
  let v = _v.replace(/\D/g, "");
  v = v.substring(0, 11);
  if (!v.length) return "";

  let res = "+" + v.substring(0, 1);
  if (v.length > 1) res += " (" + v.substring(1, 4);
  if (v.length > 4) res += ") " + v.substring(4, 7);
  if (v.length > 7) res += "-" + v.substring(7, 9);
  if (v.length > 9) res += "-" + v.substring(9, 11);

  return res;
};

export const formatDate = (src = "") => {
  if (!src) return "";
  const d = src.substring(0, 10).split("-");
  d[1] = parseInt(d[1]);
  const m = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];
  return d[2] + " " + m[d[1] - 1] + " " + d[0];
};
